<template>
  <div class="time-tracker" style="
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      background: var(--cleed-bg-top-bar);
      padding: 10px;
    ">
    <div style="
        font-size: 12px;
        margin-bottom: 10px;
        display: flex;
        gap: 5px;
        align-items: center;
      ">
      <div class="online-status" :style="online_status_style"></div>
      {{ status_text }}
      <span>
        <timer v-if="$store.state.user?.user_session?.total_time_spent && !$store.state.user.user_session?.finishes_conditions" :initTime="$store.state.user.user_session.total_time_spent" />
      </span>
    </div>  
    <!-- <div style="
        width: 35%;
        background-color: #dddddd;
        border-radius: 15px;
        overflow: hidden;
        border: 1px solid #000;
      ">

      
      <div :style="progress_bar_style"></div> 
    </div> -->

    <div :style="dots_bar_style">
      <span v-for="i in 5" :key="i" :style="buttonStyle(i - 1, progress)"></span>
    </div>
  </div>
</template>

<script>
import Timer from './Timer.vue';

export default {
  name: "TimeTracker",

  components: {
    Timer,
  },
  computed: {    
    dots_bar_style() {
      return {
        display: "flex",
        gap: "5px",
        padding: "5px",
        justifyContent: "space-between",
        width: "30%",
      };
    },
    buttonStyle() {
      return (i, progress) => {
        return {
          width: "10px",
          height: "10px",
          borderRadius: "50%",
          backgroundColor: progress > 20 * i ? "var(--cleed-bg-header)" : "#cdd7df",
        };
      };
    },
    progress(){
      const total_steps = 5;
      let current_step = 1; 
      const step_match = {
        "ending_intro": 2,          // endeing the intro qcm
        "before_ending": 3,         // ending of 10 questions question
        "reddition_ending3": 4,     // ending of the outro qcm "ending_phase"
        "satisfaction6": 5          // ending of the satisfaction
      };
      const data = Object.entries(this.$store.state.user.data);
      for (const step in step_match) {
        if (step_match.hasOwnProperty(step) && this.containsString(data, step)) {
          current_step = Math.max(current_step, step_match[step]);
        }
      }
      return (current_step / total_steps) * 100;
    },
    progress_bar_style() {
      return {
        width: `${this.progress}%`,
        height: "0.5em",
        backgroundColor: this.progress > 0 ? "#000" : "transparent",
        transition: "width 1.05s linear",
        borderRadius: "15px",
        border: "0.15em solid #DDDDDD",
      };
    },

    online_status_style() {
      return {
        width: "0.5em",
        height: "0.5em",
        borderRadius: "50%",
        backgroundColor: "#00FF00",
      };
    },

    status_text() {
      let status = this.$store.state.user.page_subtitle;
      if (status.length > 30) { // fix for error breaking top bar if text too long
        status = status.slice(0, 30) + "...";
      }
      return status
    },

    status_time() {
      let calculatedTime = 30;
      return `${calculatedTime}mn`;
    }
  },
  methods: {
    /**
   * Checks if an array contains a string.
   * @param {Array} array - The array to search in. Ex : [ ["a", "b"], ["c", "d"] ...]
   * @param {string} searchString - The string to search for. Ex : "a"
   * @returns {boolean} - True if the array contains the string, false otherwise. 
   */
    containsString(array, searchString) { /// TODO : move to utils same as in the controller index
      for (let i = 0; i < array.length; i++) {
        if (array[i].includes(searchString)) {
          return true;
        }
      }
      return false;
    }

  },
};
</script>

